import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import { useToggleTenantAutoApproval } from '@modules/users/hooks';
import { useUserManagementStore } from '@modules/users/store/hooks';
import { UserManagementActionType } from '@modules/users/store/userManagementActionType';
import { trackUserManagementEvents } from '@modules/workspaceSettings/utils';
import { LoadingButton } from '@mui/lab';
import {
  Alert,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Stack,
  Typography,
} from '@mui/material';

export const ConfirmAutoApproveOffDialog = () => {
  const { closeModal } = useMuiModalContext();
  const dispatch = useUserManagementStore(({ dispatch }) => dispatch);

  const { toggleAutoApproval, isLoading: isToggleRequestInProgress } =
    useToggleTenantAutoApproval({
      onSuccess: () => {
        dispatch({
          type: UserManagementActionType.SET_AUTO_APPROVAL_STATE,
          payload: {
            isAutoApprovalDisabled: true,
          },
        });
        closeModal();
        trackUserManagementEvents({
          eventName: 'User Management - Auto Approval Toggled Off',
        });
      },
    });

  return (
    <>
      <DialogTitle>Turn Off Auto-approval?</DialogTitle>
      <Divider light />
      <DialogContent>
        <Stack spacing={2}>
          <Typography variant="body2">
            Are you sure you want to disable auto-approval for new users from
            your organization?
          </Typography>
          <Alert severity="warning">
            When disabled, new users will only be able to sign-up via an
            invitation.
          </Alert>
        </Stack>
      </DialogContent>
      <Divider light />
      <DialogActions sx={{ my: 1, mx: 2 }}>
        <Button
          autoFocus
          variant="contained"
          color="primary"
          onClick={() => closeModal()}
        >
          Cancel
        </Button>
        <LoadingButton
          autoFocus
          loading={isToggleRequestInProgress}
          variant="outlined"
          color="error"
          onClick={() => toggleAutoApproval(true)}
        >
          Turn Off Auto-approval
        </LoadingButton>
      </DialogActions>
    </>
  );
};
